import React, { useState, useEffect } from 'react';
import { Table, Modal, Button } from 'react-bootstrap';
import Sidebar from '../Components/Siderbar';
import axios from 'axios';
import '../Customize_Css/AddProductImage.css';
import '../Customize_Css/AddProducts.css';
import { FaBoxOpen, FaPlus, FaStore, FaEdit, FaArrowLeft } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const AddProducts = () => {
  const [showModal, setShowModal] = useState(false);
  const epicxTenantId = localStorage.getItem('epicxTenantId');
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const AuthorizationToken = localStorage.getItem('token');
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [productName, setProductName] = useState('');
  const [categoryName, setCategoryName] = useState('');
  const [productVendorId, setProductVendorId] = useState('');
  const [availabilityStatus, setAvailabilityStatus] = useState('');
  const [productType, setProductType] = useState('');
  const [comments, setComments] = useState('');
  const [aboutTheProduct, setAboutTheProduct] = useState('');
  const [benefits, setBenefits] = useState('');
  const [storageAndUse, setStorageAndUse] = useState('');
  const [TodaysDeals, setTodaysDeals] = useState(false);
  const [FastMoving, setFastMoving] = useState(false);
  const [NewlyArrived, setNewlyArrived] = useState(false);
  const [FrequantlyBroughtTogether, setFrequantlyBroughtTogether] = useState(false);
  const [ExclusiveOffersForYou, setExclusiveOffersForYou] = useState(false);
  const [vendors, setVendors] = useState([]);
  const [selectedVendor, setSelectedVendor] = useState('');
  const [selectedVendorName, setSelectedVendorName] = useState('');
  const [productStates, setProductStates] = useState({});
  const [savedProducts, setSavedProducts] = useState([]);
  const [errors, setErrors] = useState({});
  const [validFields, setValidFields] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const handleShowModal = (product, selectedVendorName, category) => {
    if (!productStates[product]?.measurement?.trim()) {
      setErrors((prev) => ({
        ...prev,
        [`measurement_${product}`]: 'Measurement is required',
      }));
      return;
    }
    setProductName(product);
    setProductVendorId(selectedVendorName);
    setCategoryName(category);
    setShowModal(true);
    console.log('Product Name:', product, 'Select Vendor:', selectedVendorName, 'categoryName', category);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setErrors({});
    setValidFields({});
    setAvailabilityStatus('');
    setProductType('');
    setComments('');
    setAboutTheProduct('');
    setBenefits('');
    setStorageAndUse('');
    setTodaysDeals(false);
    setFastMoving(false);
    setNewlyArrived(false);
    setFrequantlyBroughtTogether(false);
    setExclusiveOffersForYou(false);
  };

  const validateField = (id, value) => {
    const isEmpty = (val) => !val || val.toString().trim() === '';
    const validationRules = {
      productName: { message: 'Product Name is required', validator: (val) => !isEmpty(val) },
      productVendorId: { message: 'Product Vendor ID is required', validator: (val) => !isEmpty(val) },
      categoryName: { message: 'Category Name is required', validator: (val) => !isEmpty(val) },
      aboutTheProduct: { message: 'About the Product is required', validator: (val) => !isEmpty(val) },
      benefits: { message: 'Benefits are required', validator: (val) => !isEmpty(val) },
      storageAndUse: { message: 'Storage and Use details are required', validator: (val) => !isEmpty(val) },
      availabilityStatus: { message: 'Availability Status is required', validator: (val) => !isEmpty(val) },
      // productType: { message: 'Product Type is required', validator: (val) => !isEmpty(val) },
      checkboxes: {
        message: 'At least one checkbox (Todays Deals, Fast Moving, Newly Arrived) must be selected',
        validator: () => TodaysDeals || FastMoving || NewlyArrived,
      },
      comments: { message: 'Comments cannot be blank if provided', validator: (val) => !val || !isEmpty(val) },
    };

    if (id.startsWith('measurement_')) {
      const isValid = !isEmpty(value);
      setErrors((prev) => ({
        ...prev,
        [id]: isValid ? '' : 'Measurement is required',
      }));
      setValidFields((prev) => ({
        ...prev,
        [id]: isValid,
      }));
      return isValid;
    }

    const rule = validationRules[id];
    if (!rule) return true;

    const isValid = rule.validator(value);
    setErrors((prev) => ({
      ...prev,
      [id]: isValid ? '' : rule.message,
    }));
    setValidFields((prev) => ({
      ...prev,
      [id]: isValid,
    }));
    return isValid;
  };

  const validateProductDetailsForm = () => {
    const fieldsToValidate = [
      'productName',
      'productVendorId',
      'categoryName',
      'aboutTheProduct',
      'benefits',
      'storageAndUse',
      'availabilityStatus',
      'productType',
      'checkboxes',
      'comments',
    ];

    let isValid = true;
    fieldsToValidate.forEach((id) => {
      const value =
        id === 'productName'
          ? productName
          : id === 'productVendorId'
          ? productVendorId
          : id === 'categoryName'
          ? categoryName
          : id === 'aboutTheProduct'
          ? aboutTheProduct
          : id === 'benefits'
          ? benefits
          : id === 'storageAndUse'
          ? storageAndUse
          : id === 'availabilityStatus'
          ? availabilityStatus
          : id === 'productType'
          ? productType
          : id === 'comments'
          ? comments
          : null;
      if (!validateField(id, value) && id !== 'checkboxes') {
        isValid = false;
      }
    });

    if (!validateField('checkboxes', null)) {
      isValid = false;
    }

    return isValid;
  };

  const handleSubmit = async () => {
    if (!validateProductDetailsForm()) {
      return;
    }
    const productDetails = {
      productName,
      productVendorId,
      categoryName,
      measurement: productStates[productName]?.measurement || '',
      stock: productStates[productName]?.stock || '',
      perItemPrice: productStates[productName]?.perItemPrice || '',
      TodaysDeals,
      FastMoving,
      NewlyArrived,
      FrequantlyBroughtTogether,
      ExclusiveOffersForYou,
      aboutTheProduct,
      benefits,
      storageAndUse,
      productType,
      productVendorName: selectedVendorName,
      comments
    };

    try {
      const response = await axios.post(
        `${BASE_URL}/products/api/productDetails/${epicxTenantId}`,
        { productDetails },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${AuthorizationToken}`,
          },
        }
      );
      console.log('Product successfully added:', response.data);
      setSavedProducts((prevSavedProducts) => [
        ...prevSavedProducts,
        { productName, categoryName },
      ]);
      handleCloseModal();
    } catch (error) {
      console.error('Error adding product:', error.response?.data);
      const errorMessage = error.response?.data?.message || 'Failed to add product. Please try again.';
      setErrors((prev) => ({
        ...prev,
        form: errorMessage,
      }));
    }
  };

  const fetchVendors = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/vendor/api/vendor/${epicxTenantId}`, {
        headers: {
          Authorization: `Bearer ${AuthorizationToken}`,
        },
      });
      setVendors(response.data.vendors);
    } catch (error) {
      console.error('Error fetching vendors:', error);
    }
  };

  const handleVendorChange = (e) => {
    const vendorId = e.target.value;
    setSelectedVendor(vendorId);
    setCurrentPage(1);
    const vendor = vendors.find((v) => v._id === vendorId);
    if (vendor) {
      setSelectedVendorName(vendor.vendorName);
      console.log('Selected Vendor Name:', vendor.vendorName);
    } else {
      setSelectedVendorName('');
    }
  };

  useEffect(() => {
    const fetchProducts = async () => {
      if (!selectedVendor) {
        setProducts([]);
        setProductStates({});
        console.log('selectedVendor is empty or null, skipping API call.');
        return;
      }

      try {
        let url = `${BASE_URL}/products/api/products/vendorBased?productVendorId=${encodeURIComponent(
          selectedVendor
        )}`;
        const response = await fetch(url, {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${AuthorizationToken}`,
          },
        });

        if (!response.ok) {
          throw new Error('Network response was not ok');
        }

        const data = await response.json();
        console.log('data document', data);
        setProducts(data);
      } catch (error) {
        console.error('Error fetching products:', error);
      }
    };

    fetchProducts();
  }, [selectedVendor]);

  useEffect(() => {
    if (products && products.productsByCategory) {
      const initialStates = {};
      Object.entries(products.productsByCategory).forEach(([category, productList]) => {
        productList.forEach((product) => {
          initialStates[product] = {
            measurement: '',
            stock: '',
            perItemPrice: '',
          };
        });
      });
      setProductStates(initialStates);
    }
  }, [products]);

  const handleMeasurementChange = (product, value) => {
    setProductStates((prevState) => ({
      ...prevState,
      [product]: {
        ...prevState[product],
        measurement: value,
      },
    }));
    validateField(`measurement_${product}`, value);
  };

  const handleCheckboxChange = (e) => {
    const { id, checked } = e.target;
    switch (id) {
      case 'todaysDeals':
        setTodaysDeals(checked);
        break;
      case 'fastMoving':
        setFastMoving(checked);
        break;
      case 'newlyArrived':
        setNewlyArrived(checked);
        break;
      case 'frequantlyBroughtTogether':
        setFrequantlyBroughtTogether(checked);
        break;
      case 'exclusiveOffersForYou':
        setExclusiveOffersForYou(checked);
        break;
      default:
        break;
    }
    validateField('checkboxes', null);
  };

  const availableProducts =
    products && products.productsByCategory
      ? Object.entries(products.productsByCategory).flatMap(([category, productList]) =>
          productList
            .filter(
              (product) =>
                !savedProducts.some(
                  (savedProduct) =>
                    savedProduct.productName === product.productName &&
                    savedProduct.categoryName === category
                )
            )
            .map((product) => ({ product, category }))
        )
      : [];

  const totalPages = Math.ceil(availableProducts.length / itemsPerPage);
  const indexOfLastProduct = currentPage * itemsPerPage;
  const indexOfFirstProduct = indexOfLastProduct - itemsPerPage;
  const currentProducts = availableProducts.slice(indexOfFirstProduct, indexOfLastProduct);

  useEffect(() => {
    if (totalPages === 0 && currentPage !== 1) {
      setCurrentPage(1);
    } else if (totalPages > 0 && currentPage > totalPages) {
      setCurrentPage(totalPages);
    }
  }, [currentPage, totalPages]);

  return (
    <>
      <Sidebar />
      <div className="add-products-page">
        <div className="add-products-shell">
          <header className="add-products-hero">
            <div>
              <p className="add-products-kicker">Inventory</p>
              <h1>Add Products</h1>
              <p>Select a vendor, choose a measurement, and complete the product information.</p>
            </div>
            <button
              type="button"
              className="add-products-back-btn"
              onClick={() => navigate('/viewProducts')}
            >
              <FaArrowLeft aria-hidden="true" /> Back to Products
            </button>
          </header>

          <section className="add-products-toolbar">
            <div className="add-products-vendor-filter">
              <label htmlFor="vendorDropdown">Vendor</label>
              <div className="add-products-select-wrap">
                <FaStore aria-hidden="true" />
            <select
              className="form-select"
              id="vendorDropdown"
              value={selectedVendor}
              onChange={handleVendorChange}
              onClick={fetchVendors}
            >
              <option value="">Select Vendor</option>
              {vendors.map((vendor) => (
                <option key={vendor._id} value={vendor._id}>
                  {vendor.vendorName}
                </option>
              ))}
            </select>
              </div>
            </div>
            <p>Products available for the selected vendor will appear below.</p>
          </section>

          <div className="add-products-card">
            <div className="add-products-card-head">
              <div>
                <h2>Available Products</h2>
                <p>
                  {selectedVendorName
                    ? `Choose products from ${selectedVendorName}`
                    : 'Select a vendor to get started'}
                </p>
              </div>
              <span className="add-products-vendor-badge">
                <FaBoxOpen aria-hidden="true" />
                {selectedVendorName || 'No vendor selected'}
              </span>
            </div>
            <div className="add-products-card-body">
              <div className="add-products-table-wrap">
                <Table responsive className="add-products-table">
                  <thead>
                    <tr>
                      <th>Product Name</th>
                      <th>Vendor</th>
                      <th>Category</th>
                      <th>
                        Measurement <span className="add-products-required">*</span>
                      </th>
                      <th className="add-products-action-cell">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentProducts.length > 0 ? (
                      currentProducts.map(({ product, category }) => (
                            <tr key={`${category}-${product.productName}`}>
                              <td><strong className="add-products-name">{product.productName}</strong></td>
                              <td>{selectedVendorName}</td>
                              <td><span className="add-products-category">{category}</span></td>
                              <td>
                                <select
                                  className={`form-select ${
                                    errors[`measurement_${product.productName}`]
                                      ? 'is-invalid'
                                      : validFields[`measurement_${product.productName}`]
                                      ? 'is-valid'
                                      : ''
                                  }`}
                                  value={productStates[product.productName]?.measurement || ''}
                                  onChange={(e) => handleMeasurementChange(product.productName, e.target.value)}
                                >
                                  <option value="">Select Unit</option>
                                  <option value="KG">KG</option>
                                  <option value="Litre">Litre</option>
                                  <option value="Piece">Piece</option>
                                </select>
                                {errors[`measurement_${product.productName}`] && (
                                  <small className="text-danger">
                                    {errors[`measurement_${product.productName}`]}
                                  </small>
                                )}
                              </td>
                              <td className="add-products-action-cell">
                                <button
                                  className="add-products-row-btn"
                                  onClick={() =>
                                    handleShowModal(product.productName, selectedVendor, category)
                                  }
                                >
                                  <FaPlus aria-hidden="true" /> Add Details
                                </button>
                              </td>
                            </tr>
                          ))
                    ) : (
                      <tr>
                        <td colSpan={5}>
                          <div className="add-products-empty">
                            <span><FaBoxOpen aria-hidden="true" /></span>
                            <h3>{selectedVendorName ? 'No products available' : 'Select a vendor'}</h3>
                            <p>
                              {selectedVendorName
                                ? 'There are no more products available for this vendor.'
                                : 'Choose a vendor above to view their products.'}
                            </p>
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            </div>
            {availableProducts.length > 0 && (
              <div className="add-products-card-footer">
                <span>
                  Showing {indexOfFirstProduct + 1}–{Math.min(indexOfLastProduct, availableProducts.length)} of{' '}
                  {availableProducts.length}
                </span>
                <nav aria-label="Available products pagination">
                  <ul className="pagination mb-0">
                    <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                      <button
                        className="page-link"
                        onClick={() => setCurrentPage(1)}
                        aria-label="First page"
                      >
                        «
                      </button>
                    </li>
                    <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                      <button
                        className="page-link"
                        onClick={() => setCurrentPage((page) => Math.max(page - 1, 1))}
                        aria-label="Previous page"
                      >
                        ‹
                      </button>
                    </li>
                    <li className="page-item active">
                      <button className="page-link" aria-current="page">
                        {currentPage}
                      </button>
                    </li>
                    <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                      <button
                        className="page-link"
                        onClick={() => setCurrentPage((page) => Math.min(page + 1, totalPages))}
                        aria-label="Next page"
                      >
                        ›
                      </button>
                    </li>
                    <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                      <button
                        className="page-link"
                        onClick={() => setCurrentPage(totalPages)}
                        aria-label="Last page"
                      >
                        »
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>
            )}
          </div>
          <Modal show={showModal} onHide={handleCloseModal} size="xl" dialogClassName="add-product-modal">
            <Modal.Header closeButton className="add-product-modal-header">
              <Modal.Title>
                <span className="add-product-modal-icon"><FaEdit aria-hidden="true" /></span>
                <span>
                  <small>Inventory</small>
                  Add New Product
                </span>
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className="add-product-modal-body">
              <section className="add-product-modal-section">
                <div className="add-product-section-heading">
                  <h5>Product Information</h5>
                  <p>Set the product status and choose where it should be featured.</p>
                </div>
                <div className="add-product-section-body">
                  <div className="row">
                    <div className="col-md-4 mb-3">
                      <label htmlFor="productName" className="form-label">
                        Product Name
                      </label>
                      <span style={{ color: 'red' }}>*</span>
                      <input
                        type="text"
                        className={`form-control bg-light ${
                          errors.productName ? 'is-invalid' : validFields.productName ? 'is-valid' : ''
                        }`}
                        id="productName"
                        placeholder="Enter Product Name"
                        value={productName}
                        readOnly
                      />
                      {errors.productName && <small className="text-danger">{errors.productName}</small>}
                    </div>
                    <div className="col-md-4 mb-3">
                      <label htmlFor="availabilityStatus" className="form-label">
                        Availability Status
                      </label>
                      <span style={{ color: 'red' }}>*</span>
                      <select
                        className={`form-select bg-light ${
                          errors.availabilityStatus
                            ? 'is-invalid'
                            : validFields.availabilityStatus
                            ? 'is-valid'
                            : ''
                        }`}
                        id="availabilityStatus"
                        value={availabilityStatus}
                        onChange={(e) => {
                          setAvailabilityStatus(e.target.value);
                          validateField('availabilityStatus', e.target.value);
                        }}
                      >
                        <option value="" disabled>
                          Select status
                        </option>
                        <option value="available">Available</option>
                        <option value="outOfStock">Out of Stock</option>
                        <option value="discontinued">Discontinued</option>
                      </select>
                      {errors.availabilityStatus && (
                        <small className="text-danger">{errors.availabilityStatus}</small>
                      )}
                    </div>
                    {/* <div className="col-md-4 mb-3">
                      <label htmlFor="productType" className="form-label">
                        Product Type
                      </label>
                      <span style={{ color: 'red' }}>*</span>
                      <select
                        className={`form-select bg-light ${
                          errors.productType ? 'is-invalid' : validFields.productType ? 'is-valid' : ''
                        }`}
                        id="productType"
                        value={productType}
                        onChange={(e) => {
                          setProductType(e.target.value);
                          validateField('productType', e.target.value);
                        }}
                      >
                        <option value="" disabled>
                          Select Product Type
                        </option>
                        <option value="Perishable">Perishable</option>
                        <option value="Non-Perishable">Non-Perishable</option>
                      </select>
                      {errors.productType && <small className="text-danger">{errors.productType}</small>}
                    </div> */}
                    <div className="row add-product-feature-section">
                      <div className="add-product-feature-heading">
                        <h6>Product Visibility</h6>
                        <p>Choose where this product should be featured. <span className="add-products-required">*</span></p>
                      </div>
                      <div className="col-md-2">
                        <div className="form-check">
                          <input
                            className="form-check-input custom-checkbox"
                            type="checkbox"
                            id="fastMoving"
                            checked={FastMoving}
                            onChange={handleCheckboxChange}
                          />
                          <label className="form-check-label" htmlFor="fastMoving">
                            Fast Moving
                          </label>
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div className="form-check">
                          <input
                            className="form-check-input custom-checkbox"
                            type="checkbox"
                            id="newlyArrived"
                            checked={NewlyArrived}
                            onChange={handleCheckboxChange}
                          />
                          <label className="form-check-label" htmlFor="newlyArrived">
                            Newly Arrived
                          </label>
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div className="form-check">
                          <input
                            className="form-check-input custom-checkbox"
                            type="checkbox"
                            id="todaysDeals"
                            checked={TodaysDeals}
                            onChange={handleCheckboxChange}
                          />
                          <label className="form-check-label" htmlFor="todaysDeals">
                            Todays Deals
                          </label>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-check">
                          <input
                            className="form-check-input custom-checkbox"
                            type="checkbox"
                            id="frequantlyBroughtTogether"
                            checked={FrequantlyBroughtTogether}
                            onChange={handleCheckboxChange}
                          />
                          <label className="form-check-label" htmlFor="frequantlyBroughtTogether">
                            Frequently Brought Together
                          </label>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-check">
                          <input
                            className="form-check-input custom-checkbox"
                            type="checkbox"
                            id="exclusiveOffersForYou"
                            checked={ExclusiveOffersForYou}
                            onChange={handleCheckboxChange}
                          />
                          <label className="form-check-label" htmlFor="exclusiveOffersForYou">
                            Exculusive Offers For You
                          </label>
                        </div>
                      </div>
                      {errors.checkboxes && (
                        <div className="col-12">
                          <small className="text-danger">{errors.checkboxes}</small>
                        </div>
                      )}
                    </div>

                    <div className="row add-product-comments">
                      <label htmlFor="comments" className="form-label">
                        Comments
                      </label>
                      <textarea
                        className={`form-control bg-light ${
                          errors.comments ? 'is-invalid' : validFields.comments ? 'is-valid' : ''
                        }`}
                        id="comments"
                        rows="2"
                        placeholder="Enter any comments or notes"
                        value={comments}
                        onChange={(e) => {
                          setComments(e.target.value);
                          validateField('comments', e.target.value);
                        }}
                      ></textarea>
                      {errors.comments && <small className="text-danger">{errors.comments}</small>}
                    </div>
                  </div>
                </div>
              </section>
              <section className="add-product-modal-section">
                <div className="add-product-section-heading">
                  <h5>General Information</h5>
                  <p>Add the description, benefits, and storage guidance.</p>
                </div>
                <div className="add-product-section-body">
                  <div className="row">
                    <div className="col-md-4">
                      <label htmlFor="aboutTheProduct" className="form-label">
                        About the Product
                      </label>
                      <span style={{ color: 'red' }}>*</span>
                      <textarea
                        className={`form-control bg-light ${
                          errors.aboutTheProduct
                            ? 'is-invalid'
                            : validFields.aboutTheProduct
                            ? 'is-valid'
                            : ''
                        }`}
                        id="aboutTheProduct"
                        rows="2"
                        value={aboutTheProduct}
                        onChange={(e) => {
                          setAboutTheProduct(e.target.value);
                          validateField('aboutTheProduct', e.target.value);
                        }}
                      ></textarea>
                      {errors.aboutTheProduct && (
                        <small className="text-danger">{errors.aboutTheProduct}</small>
                      )}
                    </div>
                    <div className="col-md-4">
                      <label htmlFor="benefits" className="form-label">
                        Benefits
                      </label>
                      <span style={{ color: 'red' }}>*</span>
                      <textarea
                        className={`form-control bg-light ${
                          errors.benefits ? 'is-invalid' : validFields.benefits ? 'is-valid' : ''
                        }`}
                        id="benefits"
                        rows="2"
                        value={benefits}
                        onChange={(e) => {
                          setBenefits(e.target.value);
                          validateField('benefits', e.target.value);
                        }}
                      ></textarea>
                      {errors.benefits && <small className="text-danger">{errors.benefits}</small>}
                    </div>
                    <div className="col-md-4">
                      <label htmlFor="storageAndUse" className="form-label">
                        Storage and Use
                      </label>
                      <span style={{ color: 'red' }}>*</span>
                      <textarea
                        className={`form-control bg-light ${
                          errors.storageAndUse
                            ? 'is-invalid'
                            : validFields.storageAndUse
                            ? 'is-valid'
                            : ''
                        }`}
                        id="storageAndUse"
                        rows="2"
                        value={storageAndUse}
                        onChange={(e) => {
                          setStorageAndUse(e.target.value);
                          validateField('storageAndUse', e.target.value);
                        }}
                      ></textarea>
                      {errors.storageAndUse && (
                        <small className="text-danger">{errors.storageAndUse}</small>
                      )}
                    </div>
                  </div>
                </div>
              </section>
            </Modal.Body>
            <Modal.Footer className="add-product-modal-footer">
              <Button
                onClick={handleCloseModal}
                className="add-product-cancel-btn"
              >
                Cancel
              </Button>
              <Button
                onClick={handleSubmit}
                className="add-product-submit-btn"
              >
                Save Product
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    </>
  );
};

export default AddProducts;